module.exports = __webpack_public_path__ + "img/mobiotics_logo.48fd691a.svg";